import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { alpha, Box, ButtonBase, Typography } from '@mui/material';
import {
  ShopperEvent,
  chatActions,
  mapShopperEventTypeToCategory,
  useAppDispatch,
} from '@vs-online-only-app/state';
import { Carousel } from '@vs-online-only-app/ui';
import { ShopperEventsListItem } from './ShopperEventsListItem';

const ExtraEventsCountOverlay = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  background: ${({ theme }) => alpha(theme.palette.primary.main, 0.5)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

const ExtraCountWrapper = styled(Box)`
  position: 'relative';
  padding: ${({ theme }) => theme.spacing(1)};
`;

type Props = {
  maxVisible?: number;
  events?: ShopperEvent[];
};

const ShopperEventsCarousel: FC<Props> = ({ events = [], maxVisible = 10 }) => {
  const dispatch = useAppDispatch();

  const { totalCount, visibleEvents } = useMemo(
    () => ({
      visibleEvents: events.slice(0, maxVisible - 1),
      totalCount: events.length,
    }),
    [events, maxVisible]
  );

  const handleExtraEventsClick = () => {
    dispatch(
      chatActions.setSelectedShopperEventCategory(
        mapShopperEventTypeToCategory(events[maxVisible])
      )
    );
  };

  return (
    <Carousel>
      {visibleEvents.map((event) => (
        <ShopperEventsListItem event={event} key={event.id} />
      ))}
      {totalCount > maxVisible && (
        <ExtraCountWrapper style={{ position: 'relative', padding: '8px' }}>
          <ShopperEventsListItem
            event={events[maxVisible]}
            thumbnailOnly
            noTimestamp
          />
          <ExtraEventsCountOverlay onClick={handleExtraEventsClick}>
            <Typography fontWeight="bold" color="white" variant="body2">
              +{totalCount - maxVisible + 1}
            </Typography>
          </ExtraEventsCountOverlay>
        </ExtraCountWrapper>
      )}
    </Carousel>
  );
};

export default ShopperEventsCarousel;
